import headerBurger from "./components/headerBurger";
import dropdown from "./components/dropdown";
import animation from "./components/animation";
import swipers from "./components/swipers";
import hoverVideo from "./components/hoverVideo";
import GraphModal from 'graph-modal';
import intlTelInput from '../../node_modules/intl-tel-input//build/js/intlTelInput';
import intlTelInputUtils from '../../node_modules/intl-tel-input//build/js/utils';
import {form} from "./components/form";

import {cookies} from "./components/cookies";
cookies();

import phone_mask from "./functions/phone_mask";

headerBurger();
dropdown();
window.addEventListener("load", () => {
    animation();
});


swipers()
hoverVideo();
form();

export const modalInfo = new GraphModal({
    isOpen: () => {
    },
    isClose: () => {
    },
    closeEsc: true,
    focus: false
});


// new SimplePhoneMask('input[type="tel"]', {
//     showFlag: true,
//     allowCountrySelect: true,
//     detectIP: true,
//     countryCode: "ae"
// });
const inputs = document.querySelectorAll('input[type="tel"]');

function stripTrunkPrefix(example) {
    const match = example.match(/^(?:0|8|1)\s+/);
    if (!match) return example;
    return example.slice(match[0].length);
}

function buildInputmaskMask(example) {
    return example
        .replace(/\d/g, "9")
        .replace(/\(/g, "\\(")
        .replace(/\)/g, "\\)")
        .replace(/-/g, "\\-");
}

inputs.forEach((input) => {
    const iti = intlTelInput(input, {
        initialCountry: "ae",
        separateDialCode: true,
        utilsScript: "/intl-tel-input/js/utils.js",
    });

    function applyMask() {
        const country = iti.getSelectedCountryData();
        if (!country) return;

        let example = intlTelInputUtils.getExampleNumber(
            country.iso2,
            true,
            intlTelInputUtils.numberFormat.NATIONAL
        );
        if (!example) return;

        example = stripTrunkPrefix(example);
        const mask = buildInputmaskMask(example);

        Inputmask.remove(input);
        Inputmask({
            mask,
            showMaskOnHover: false,
            clearIncomplete: true,
            placeholder: "_",
            insertMode: false,
            positionCaretOnClick: "radixFocus",
            jitMasking: true,
            keepStatic: true,
        }).mask(input);
    }

    applyMask();
    input.addEventListener("countrychange", applyMask);
});

document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href || href === "#") return;

    const id = href.slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({behavior: "smooth", block: "start"});
});
